import Vue from 'vue'
import Vuex from 'vuex'
import api from './utils/axios.js'
Vue.use(Vuex)



export default new Vuex.Store({
	state: {
		login: false,
		gamelist: [],
		open_login:false,
		isMobile: false,
		userinfo: {},
		config: {},
		allGameList:[],
		loading: false,
		backupMode: false,
		backupModeEnabled: true,
		backupTimeRange: '24h'
	},
	getters: {
		login: state => state.login,
		open_login: state => state.open_login,
		isMobile: state => state.isMobile,
		gamelist: state => state.gamelist,
		userinfo: state => state.userinfo,
		config: state => state.config,
		allGameList: state => state.allGameList,
		isAdmin: state => state.userinfo.group_id === 0,
		backupMode: state => state.backupModeEnabled && state.backupMode,
		backupTimeRange: state => state.backupTimeRange,


	},
	mutations: {
		SET_login: (state, login) => state.login = login,
		SET_userinfo: (state, userinfo) => state.userinfo = userinfo,
		SET_IS_MOBILE: (state, isMobile) => state.isMobile = isMobile,
		SET_config: (state, config) => state.config = config,
		SET_gamelist: (state, gamelist) => state.gamelist = gamelist,
		SET_allGameList: (state, allGameList) => state.allGameList = allGameList,
		SET_open_login: (state, open_login) => state.open_login = open_login,
		SET_backupMode: (state, backupMode) => state.backupMode = backupMode,
		SET_backupModeEnabled: (state, backupModeEnabled) => state.backupModeEnabled = backupModeEnabled,
		SET_backupTimeRange: (state, backupTimeRange) => state.backupTimeRange = backupTimeRange,


	},
	actions: {
		//全局配置
		getCenterConfig: ({
			commit,
		}) => {

			api.requests.post("api/game/hall/getSite", {
				id: 1,
			}).then(res => {
				
				commit('SET_config', res.data)
			}).catch(error => {

			})
		},
		
		//获取备份模式配置
		getBackupModeConfig: ({
			commit,
		}) => {
			api.requests.post("api/game/hall/getBackupModeConfig").then(res => {
				if (res.code === 1 && res.data) {
					commit('SET_backupTimeRange', res.data.time_range || '24h')
				}
			}).catch(error => {

			})
		},
		
		//
		getgameGameList: ({
			commit,
		}) => {

			api.requests.post("api/game/hall/gameList", {
				id: 1,
			}).then(res => {
				commit('SET_gamelist', res.data)
			}).catch(error => {

			})
		},
		getAllgameGameList: ({
			commit,
		}) => {

			api.requests.post("api/game/hall/getNewGameList", {
				id: 1,
			}).then(res => {
				commit('SET_allGameList', res.data)
			}).catch(error => {

			})
		},
	},
	modules: {


	}
})